var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "public-transport-selection" }, [
    _c(
      "div",
      { staticClass: "public-transportation-modal" },
      [
        _c("p", [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("checkout.personalisation.publicTransport.orderText")
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _vm.loading
          ? [_c("spinner")]
          : [
              _vm._l(
                _vm.additionalOrderItemConfigs,
                function (additionalOrderItemConfig, index) {
                  return [
                    _c("public-transport-item", {
                      key:
                        "config-" +
                        additionalOrderItemConfig.productId +
                        "-" +
                        additionalOrderItemConfig.slotId +
                        "-" +
                        index,
                      attrs: { aoic: additionalOrderItemConfig },
                      on: {
                        updateAdditionalOrderItemConfig:
                          _vm.updateAdditionalOrderItemConfig,
                      },
                    }),
                  ]
                }
              ),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }